<template>
  <div class="apps-container">
    <div class="apps-inner">
      <div class="category">
        <div>
          <span class="active" @click="selectCategory">全部</span>
          <span v-for="item in categoryList" :key="item.id" @click="selectCategory($event, item)">
            {{ item.name }}</span>
        </div>
      </div>
      <div class="app" v-for="{ id, name, children } in appList" :data-title="name" :key="id">
        <div v-for="{ id, name, customIcon, sourceType, url } in children" :key="id"
          @click="clickApp(sourceType, id, url)">
          <img :src="baseUrl + customIcon" alt="">
          <span>{{ name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const { jumpURL } = projectConfig
import * as api from './api.js'
export default {
  name: 'Apps',
  data() {
    return {
      baseUrl: localStorage.getItem('baseUrl'),
      userRole: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).userDict : null,
      categoryList: [],
      appList: [],
      userInfo: {}
    }
  },
  async created() {
    if (this.userRole != 4) {
      const { data: { userOperationList } } = await api.getAppList({ platformType: 1 })
      this.appList = this.categoryList = userOperationList.filter(item => item.children.length)
    }
  },
  methods: {
    selectCategory(e, item) {
      const categoryList = document.querySelectorAll('.category div span')
      categoryList.forEach(item => {
        item.classList.remove('active')
      })
      e.target.classList.add('active')
      this.appList = item ? [item] : this.categoryList
    },
    async clickApp(sourceType, id, url) {
      await api.logUserClick({ idOperate: id, type: 1 })
      if (sourceType === 1) {
        url = jumpURL + url
      } else {
        const { data } = await api.getSystemParam(this.userInfo.id)
        for (const key in data) {
          url = url.replace(key, data[key])
        }
      }
      window.open(url)
    },
  }
}
</script>

<style lang="scss" scoped>
.apps-container {
  min-height: calc(100vh - 363px);

  .apps-inner {
    width: var(--inner-width);
    margin: auto;
    padding: 54px 0 109px;

    .category {
      margin-bottom: 74px;
      display: flex;
      gap: 20px;

      &::before {
        content: '应用分类';
        color: #333;
        transform: translateY(8px);
        font-size: 18px;
      }

      p {
        color: #333;
        transform: translateY(5px);
        font-size: 18px;
      }

      div {
        flex: 1;
        display: flex;
        gap: 20px;
        flex-wrap: wrap;

        span {
          background: #eee;
          padding: 8px 20px;
          color: #888;
          border-radius: 17px;
          cursor: pointer;
          transition: 300ms ease-in-out;

          &.active {
            background: $mainColor;
            color: #fff;
          }
        }
      }
    }

    .app {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 28px;
      position: relative;
      margin-top: 133px;

      &::before {
        content: attr(data-title);
        color: #333;
        font-size: 28px;
        font-weight: bold;
        position: absolute;
        top: -70px;
        font-weight: bold;
      }

      &::after {
        content: '';
        color: #333;
        width: 100%;
        height: 1px;
        background: #d9d9d9;
        font-size: 28px;
        font-weight: bold;
        position: absolute;
        top: -25px;
      }

      div {
        height: 90px;
        display: flex;
        align-items: center;
        background: #fff;
        padding: 20px;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        cursor: pointer;
        transition: 300ms;

        &:hover {
          border-color: $mainColor;
          scale: .97;
        }

        img {
          height: 44px;
          margin-right: 20px;
        }

        span {
          font-size: 20px;
          color: #333;
        }
      }
    }
  }
}
</style>